(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RacePositionsDeleteController',RacePositionsDeleteController);

    RacePositionsDeleteController.$inject = ['$uibModalInstance', 'entity', 'RacePositions'];

    function RacePositionsDeleteController($uibModalInstance, entity, RacePositions) {
        var vm = this;

        vm.racePositions = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RacePositions.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
